function convertSlideIndexToUUID(index, slides) {
    try {
        return slides[index].uuid;
    } catch (error) {
        console.log(index)
        console.log(slides)
        console.log(error.message)
        return index;
    }
}

function convertSlideUUIDToIndex(uuid, slides) {
    for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];
        if (slide.uuid === uuid) return i;
    }

    return undefined;
}

export { convertSlideIndexToUUID, convertSlideUUIDToIndex };